var _circle, _path, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ef8035",
    cx: 50,
    cy: 50,
    r: 41.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b56127",
    d: "M50,93.97c-24.25,0-43.97-19.72-43.97-43.97S25.75,6.03,50,6.03s43.97,19.72,43.97,43.97-19.72,43.97-43.97,43.97ZM50,10.03c-22.04,0-39.97,17.93-39.97,39.97s17.93,39.97,39.97,39.97,39.97-17.93,39.97-39.97S72.04,10.03,50,10.03Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#914e1e",
    cx: 36.03,
    cy: 50,
    r: 6.69
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#914e1e",
    cx: 63.97,
    cy: 50,
    r: 6.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#914e1e",
    d: "M61.51,71.97h-23.02c-1.04,0-1.89-.85-1.89-1.89s.85-1.89,1.89-1.89h23.02c1.04,0,1.89.85,1.89,1.89s-.84,1.89-1.89,1.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackNeutral);
export default __webpack_public_path__ + "static/media/feedback-neutral.f956a23b7d4ac3983189e740b34d9442.svg";
export { ForwardRef as ReactComponent };